import { MemberStatus, Role } from '@prisma/client';
import { EyeOpenIcon, GearIcon, LockClosedIcon, PersonIcon } from '@radix-ui/react-icons';

export const userTypes = [
  {
    value: Role.ADMIN,
    label: 'Admin',
    icon: GearIcon,
  },
  {
    value: Role.USER,
    label: 'User',
    icon: PersonIcon,
  },
  {
    value: Role.VIEWER,
    label: 'Viewer',
    icon: EyeOpenIcon,
  },
  {
    value: Role.GUEST,
    label: 'Guest',
    icon: LockClosedIcon,
  },
];

export const callTypes = new Map<MemberStatus, string>([
  [MemberStatus.Active, 'text-green-500 border-green-500'],
  [MemberStatus.Inactive, 'text-gray-500 border-gray-500'],
  [MemberStatus.Invited, 'text-yellow-500 border-yellow-500'],
]);
